<div
  class="flex flex-col items-center justify-center rounded-lg w-full min-w-28 min-h-20 h-full p-3 relative"
  matTooltipPosition="above"
  [style.backgroundColor]="backgroundColor()"
  [matTooltip]="data().showValueTooltip ? valueTooltip() : null"
>
  @if (imageUrl()) {
    <div class="flex w-[92px] h-[124px] mb-2">
      <img [src]="imageUrl()" alt="Game Preview" class="w-[92px] h-[124px] object-cover rounded-lg" />
    </div>
  }

  @if (data().statusKpi && data().targetValue) {
    <div class="absolute top-1 right-1">
      <app-analytics-status-badge statusBackgroundColor="var(--shikenso-base-white)" [status]="data().statusKpi!" />
    </div>
  }

  <div class="flex flex-col items-start justify-center w-full gap-1">
    <div class="flex items-center gap-1 justify-start">
      @if (!data().name && !data().totalDuration && !data().badgeStatus) {
        <span class="text-[28px] leading-8">
          @if (data().isPercentage) {
            {{ data().value ? (data().value! | percentage: true) : '0' }}{{ data().targetValue ? '' : '%' }}
          } @else {
            {{ data().value ? (data().value! | numberSuffix) : '0' }}
          }
        </span>
      }

      @if (data().badgeStatus && data().badgeColorScheme) {
        <app-status-badge class="my-2" [status]="data().badgeStatus!" [colorScheme]="data().badgeColorScheme!" />
      }

      @if (data().targetValue) {
        <div class="text-xs text-shikenso-purple-base-60 pt-3 flex items-center">
          <span>/</span>
          <span>
            @if (data().isPercentage) {
              {{ data().targetValue! | percentage }}%
            } @else {
              {{ data().targetValue! | numberSuffix }}
            }
          </span>
        </div>
      }

      @if (data().valueSuffix && (data().value || data().targetValue)) {
        <span class="text-xs text-shikenso-purple-base-60 pt-3 flex items-center">{{ data().valueSuffix }}</span>
      }

      @if (data().name) {
        <span class="text-2xl font-bold">{{ data().name || '' }}</span>
      }

      @if (data().totalDuration) {
        <span class="text-2xl font-bold">{{ data().totalDuration || '' }}</span>
      }
    </div>

    @if (data().title) {
      <div class="flex items-center gap-1 text-xs justify-center">
        @if (data().icon) {
          <app-icon-badge
            [content]="'icons/' + data().icon"
            [size]="20"
            [iconSize]="14"
            [borderRadius]="4"
            [backgroundColor]="iconBackgroundColor()"
          />
        }

        <span
          matTooltip
          matTooltipPosition="above"
          [style.maxWidth]="titleMaxWidth()"
          [ngClass]="{ 'line-clamp-1 text-ellipsis': titleMaxWidth() }"
          [appTextClampTooltip]="data().title ?? ''"
        >
          {{ data().title }}
        </span>
      </div>
    }

    @if (data().keyword) {
      <span
        class="text-xs cursor-pointer text-ellipsis overflow-hidden whitespace-nowrap block max-w-full text-center"
        matTooltipPosition="above"
        [matTooltip]="data().keyword"
      >
        {{ data().keyword }}
      </span>
    }
  </div>
</div>
